export default __webpack_public_path__ + "static/media/Wildling Hauberk.d48f963f.jpg";